<template>
    <div class="o-sms-modal-success sms-modal-success">
        <div class="sms-modal-success__layer sms-modal-success__layer--phone">
            <svg-icon
                original
                name="backgrounds/phone-frame-gray"
                class="sms-modal-success__phone-icon"
            />
        </div>
        <div class="sms-modal-success__layer sms-modal-success__layer--main">
            <svg-icon
                original
                name="icons/success"
                class="sms-modal-success__success-icon"
            />
            <span class="sms-modal-success__title">
                {{ $t('o-sms-modal-success_title')}}
            </span>
            <span class="sms-modal-success__text">
                {{ item }}
            </span>
            <span class="sms-modal-success__text sms-modal-success__text--small">
                {{ $t('o-sms-modal-success_tip') }}
            </span>
            <div class="sms-modal-success__wrapper">
                <svg-icon
                    original
                    name="icons/handset-green"
                    class="sms-modal-success__handset-icon"
                />
                {{ value }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OSmsModalSuccess",
    props: {
        value: {
            type: String,
            default: ''
        },
        item: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "o-sms-modal-success.scss";
</style>
